if (!customElements.get('lld-country-selector')) {
  customElements.define('lld-country-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.details = this.querySelector('details');
      this.search = this.querySelector('input[type="search"]');
      this.options = Array.from(this.querySelectorAll('[data-country-search]'));
      this.groups = Array.from(this.querySelectorAll('.lld-country__group'));
      this.empty = this.querySelector('.lld-country__empty');
      if (!this.details || !this.search) return;
      this.querySelector('.lld-country__search').hidden = false;
      this.search.addEventListener('input', () => this.filterCountries());
      this.details.addEventListener('toggle', () => {
        if (!this.details.open) {
          this.search.value = '';
          this.filterCountries();
        }
      });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.details.open) {
          event.stopPropagation();
          this.details.open = false;
          this.querySelector('summary').focus();
        }
      });
      this.closeOutside = (event) => {
        if (!this.contains(event.target)) this.details.open = false;
      };
      this.resetOnMenuClose = (event) => {
        if (event.target instanceof Element && event.target.closest('[data-js-popup-close], [data-js-popup-button="navigation"]')) this.details.open = false;
      };
      document.addEventListener('pointerdown', this.closeOutside);
      document.addEventListener('click', this.resetOnMenuClose);
    }
    disconnectedCallback() {
      if (this.closeOutside) document.removeEventListener('pointerdown', this.closeOutside);
      if (this.resetOnMenuClose) document.removeEventListener('click', this.resetOnMenuClose);
      this.ready = false;
    }
    filterCountries() {
      const query = this.search.value.trim().toLocaleLowerCase();
      let count = 0;
      this.options.forEach((option) => {
        const match = option.dataset.countrySearch.toLocaleLowerCase().includes(query);
        option.hidden = !match;
        if (match) count += 1;
      });
      this.groups.forEach((group) => { group.hidden = Boolean(query); });
      this.empty.hidden = count > 0;
    }
  });
}
